// src/lib/utm.ts

/**
 * Capture UTM parameters from URL and persist in sessionStorage.
 * SessionStorage survives navigation within the same tab but clears on close.
 */

const UTM_KEYS = ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term"] as const;
const STORAGE_KEY = "menuzai_utm";

export interface UtmParams {
  utm_source?: string;
  utm_medium?: string;
  utm_campaign?: string;
  utm_content?: string;
  utm_term?: string;
  referrer?: string;
}

export function captureUtmParams(): void {
  if (sessionStorage.getItem(STORAGE_KEY)) return;

  const params = new URLSearchParams(window.location.search);
  const utm: UtmParams = {};
  let hasUtm = false;

  for (const key of UTM_KEYS) {
    const value = params.get(key);
    if (value) {
      utm[key] = value;
      hasUtm = true;
    }
  }

  if (document.referrer && !document.referrer.includes(window.location.hostname)) {
    utm.referrer = document.referrer;
    hasUtm = true;
  }

  if (hasUtm) {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(utm));
  }
}

export function getUtmParams(): UtmParams {
  const stored = sessionStorage.getItem(STORAGE_KEY);
  return stored ? JSON.parse(stored) : {};
}

export function clearUtmParams(): void {
  sessionStorage.removeItem(STORAGE_KEY);
}
